import { render, staticRenderFns } from "./AjusteInventarioComponent.vue?vue&type=template&id=a8fb4634&"
import script from "./AjusteInventarioComponent.vue?vue&type=script&lang=js&"
export * from "./AjusteInventarioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports